import { render, staticRenderFns } from "./QuestionsForCategory.vue?vue&type=template&id=db5e216e&"
import script from "./QuestionsForCategory.vue?vue&type=script&lang=js&"
export * from "./QuestionsForCategory.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsForCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports